import type { TFunction } from 'i18next';
import { z } from 'zod';

const MAX_FILE_SIZE_MB = 25;
const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
const ACCEPTED_MIME_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];

export const createCertificateUploadSchema = (t: TFunction) =>
  z.object({
    accreditationType: z
      .string({
        required_error: t('upload-certificate-screen.form.validation.accreditation-type-required'),
      })
      .min(1, t('upload-certificate-screen.form.validation.accreditation-type-required')),

    certificate: z
      .string({
        required_error: t('upload-certificate-screen.form.validation.certificate-required'),
      })
      .min(1, t('upload-certificate-screen.form.validation.certificate-required')),

    certificateFile: z
      .array(z.instanceof(File))
      .min(1, t('upload-certificate-screen.form.validation.certificate-file-required'))
      .refine(
        (files) => files.every((file) => file.size <= MAX_FILE_SIZE),
        t('upload-certificate-screen.form.validation.file-too-large', { maxSize: MAX_FILE_SIZE_MB })
      )
      .refine(
        (files) => files.every((file) => ACCEPTED_MIME_TYPES.includes(file.type)),
        t('upload-certificate-screen.form.validation.unsupported-file-type')
      ),

    termsAndConditionsAccepted: z.boolean().refine((val) => val === true, {
      message: t('upload-certificate-screen.form.validation.terms-required'),
    }),

    workerId: z.string().uuid(),
  });

export type CertificateUploadFormValues = z.infer<ReturnType<typeof createCertificateUploadSchema>>;
